import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import ContentsTab   from 'contents_tab';

import ContentsModal from '@partials/contents-modal';
import CheckDrafts   from '@project/common/check-drafts';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showDraftListModal = this.showDraftListModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal  : false,
      drafts : [],
      tab    : 'all',
    };
  }
  // -------------------------------------------------------
  
  showDraftListModal(project_id) {
    Utils.request.bind(this)('/api/project/workflow/get_draft_list', { project_id: project_id },
      function(res){
        
        this.setState({ modal: true, drafts: res.body.drafts });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closeDraftListModal() {
    this.setState({ modal: false, drafts: [] });
  }
  // -------------------------------------------------------
  
  changeNavigation(tab) {
    this.setState({ tab: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let base = Object.assign({}, this.props.data);
    
    base.check_draft = [];
    this.state.drafts.map((d) => {
      
      if( this.state.tab == 'not_complete' && (d.complete == 1 || d.is_submission == 0) ) return;
      if( this.state.tab == 'draft_edit' && d.is_submission == 1 ) return;
      if( this.state.tab == 'complete' && d.complete == 0 ) return;
      
      d.sort_no = d.flow_no;
      if( d.is_submission == 0 ) d.sort_no += 1000;
      if( d.complete == 1 ) d.sort_no += 10000;
      
      base.check_draft.push(d);
    });
    base.check_draft = Utils.sort(base.check_draft, 'sort_no', 'asc');
    
    let tabs = [
      { id: 'all',          name: '全て表示',  html: <CheckDrafts base={base} /> },
      { id: 'not_complete', name: '未完了',    html: <CheckDrafts base={base} /> },
      { id: 'draft_edit',   name: '下書き中',  html: <CheckDrafts base={base} /> },
      { id: 'complete',     name: '完了済み',  html: <CheckDrafts base={base} /> },
    ];
    
    return (
      <div className="project-draft-list-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 80px)'}
          height    = {530}
          max_width = {900}
          close_ev  = {this.closeDraftListModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>すべての下書き一覧（{base.all_draft_count})</h2>
              
              <ContentsTab tabs={tabs} select={this.state.tab} font_size={16} change_ev={this.changeNavigation.bind(this)} />
              
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;